import styled from "styled-components";
import { fadeIn, appearLeft, appearRight, blinkTextCursor } from './keyframes';


export const AnimationAppearLeft = styled.div`
	animation: ${appearLeft};
	animation-duration: ${({ duration }: IAnimation) =>
    duration ? duration : 1000}ms;
`;

export const AnimationAppearRight = styled.div`
	animation: ${appearRight};
	animation-duration: ${({ duration }: IAnimation) =>
    duration ? duration : 1000}ms;
`;

export const AnimationFadeIn = styled.div`
	animation: ${fadeIn};
	animation-duration: ${({ duration }: IAnimation) =>
    duration ? duration : 600}ms;
`;

export const CursorText = styled.span`
	border-right: 2px solid white;
	display: inline;

	height: 80%;

	/* A mágica acontece aqui */
	animation: ${blinkTextCursor} 0.7s steps(44) infinite normal;
`;